// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-plan .plan-details-header {\n  font-size: 1.125em;\n  line-height: 1.25;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
